import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_get_shipments_by_shipment_idsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { shipment_ids: number[] }): 
  Promise<{ result: { Id?: number, Cartonized?: boolean, ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, LookupCode?: string, StatusId?: number, Wave?: { Id?: number, Status?: { Id?: number, Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipment_ids)) {
      $missingRequiredInParams.push('\'shipment_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { shipment_ids: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Cartonized?: boolean, ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, LookupCode?: string, StatusId?: number, Wave?: { Id?: number, Status?: { Id?: number, Name?: string } } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipment_ids)) {
      $missingRequiredInParams.push('\'shipment_ids\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { shipment_ids: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Cartonized?: boolean, ContainerSize?: string, ExpectedDate?: string, ExpectedWarehouseId?: number, LookupCode?: string, StatusId?: number, Wave?: { Id?: number, Status?: { Id?: number, Name?: string } } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipment_ids)) {
      $missingRequiredInParams.push('\'shipment_ids\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      shipment_ids: number[]    }) {
        if(isNil($inParams.shipment_ids)) {
          return true; 
        }
      return false;
    }
}
